import React from 'react';
import { Box, Link, Paper } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';
import SectionTitle from './SectionTitle';
import type { ReferenceLink } from './executiveSummaryTypes';

interface ReferenceLinksProps {
  links: ReferenceLink[];
}

const ReferenceLinks: React.FC<ReferenceLinksProps> = ({ links }) => (
  <Paper
    elevation={0}
    sx={{
      backgroundColor: '#fff',
      border: `1px solid ${SEARCE_COLORS.border}`,
      borderRadius: '10px',
      p: '20px 24px',
      boxShadow: '0 1px 4px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.03)',
      mb: '20px',
    }}
  >
    <Box sx={{ display: 'block' }}>
      <SectionTitle>Reference Links</SectionTitle>
    </Box>
    {links.length === 0 ? (
      <Box
        sx={{
          mt: '6px',
          fontSize: '0.8125rem',
          color: SEARCE_COLORS.textSecondary,
          fontStyle: 'italic',
        }}
      >
        No reference links available for this project.
      </Box>
    ) : (
      <Box
        component="ul"
        sx={{
          listStyle: 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          m: 0,
          p: 0,
        }}
      >
        {links.map((link) => (
          <Box
            component="li"
            key={link.label}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '10px',
              p: '10px 14px',
              background: '#f8fafc',
              borderRadius: '6px',
              border: '1px solid #f1f5f9',
              '&:hover': { background: '#f1f5f9' },
            }}
          >
            <Box component="span" sx={{ fontSize: '0.8125rem', color: SEARCE_COLORS.textSecondary }}>
              {link.label}
            </Box>
            <Link
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: SEARCE_COLORS.primary,
                fontWeight: 600,
                fontSize: '0.78rem',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Open →
            </Link>
          </Box>
        ))}
      </Box>
    )}
  </Paper>
);

export default ReferenceLinks;
